module.exports = __webpack_public_path__ + "static/hero2-d5baff6a8b29f810ff22bd1145157107.jpeg";